import * as basic from './basic'
import * as research from './research'
export default {
    basic,
    research
}